import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartOptions, Chart, ChartData } from 'chart.js/auto';
//import { Color, Label } from '@rinminase/ng-charts';
import { TestResultService } from '../../services/test-result.service';
import { CumulativeQuery } from '../../models/CumulativeQuery';
import { ResultCumulative } from '../../models/ResultCumulative';
import { BaseChartDirective } from 'ng2-charts';
import 'chartjs-adapter-date-fns';
import { enGB } from 'date-fns/locale';

@Component({
  selector: 'result-cumulative',
  standalone: true,
  imports: [FormsModule, BaseChartDirective ],
  templateUrl: './result-cumulative.component.html',
  styleUrl: './result-cumulative.component.css'
})

export class CumulativeComponent implements OnInit {
  private _cumulativeQuery: CumulativeQuery = new CumulativeQuery();
  private colours: string[] = [ 
    'rgba(0, 0, 0, 0.7)',
    'rgba(255, 0, 0, 0.7)',
    'rgba(0, 255, 0, 0.7)',
    'rgba(0, 0, 255, 0.7)',
    'rgba(255, 255, 0, 0.7)',
    'rgba(0, 255, 255, 0.7)',
    'rgba(255, 0, 255, 0.7)'
  ]
  @Input() set cumulativeQuery(cumulativeQuery: CumulativeQuery) {
    this._cumulativeQuery = cumulativeQuery;
    this.setData();
  }

  @Input() set shouldBeEmpty(shouldBeEmpty: boolean) {
    if (shouldBeEmpty) this.lineChartData = {
      datasets: [{
        data: [new ResultCumulative()],
        parsing: {
          xAxisKey: 't',
          yAxisKey: 'y'
        }
      }]
    };
  }
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  public fromDate = new Date(2020, 1, 1).toShortDateString(); // 1 month ago.
  public toDate = new Date().toShortDateString();
  public testCodes: string[] = [];
  public lineChartData: ChartData<'line', ResultCumulative []> = {

    datasets: [{
      data: [ ],
      parsing: {
        xAxisKey: 't',
        yAxisKey: 'y'
      }
    }]
  };
  public lineChartType = 'line';
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'time',
        offset: true,
        ticks: {
          major: {
            enabled: true
          },
          source: 'data',
          autoSkip: true,
          autoSkipPadding: 75,
          maxRotation: 0,
          sampleSize: 5
        },
      adapters: {
        date: {
          locale: enGB,
        },
      }, 
      }
    }
  };

  constructor(private testResultSevice: TestResultService) { }

  ngOnInit() {
    this.setData();
  }
 
  dateChanged(evt: any) {
    this.lineChartData = {
      datasets: [{
        data: [],
        parsing: {
          xAxisKey: 't',
          yAxisKey: 'y'
        }
      }]
    };
    this.setData();
  }
  
 
  setData() {
    if (this.testCodes.findIndex(testCode => testCode === this._cumulativeQuery.testCode) < 0) { this.testCodes.push(this._cumulativeQuery.testCode) }
    
    this.testCodes.forEach(testCode => {
      const srchCrits = { testCode: testCode, surname: this._cumulativeQuery.surname, forename: this._cumulativeQuery.forename, dob: this._cumulativeQuery.dob, fromDate: this.fromDate, toDate: this.toDate }
      this.testResultSevice.getTestResultsCumulative(srchCrits).subscribe(resultList => {
        if (this.lineChartData.datasets[0].data.length === 0) { //
          console.log('blatting data');
          this.lineChartData = {
            datasets: [{
              label: testCode,
              borderColor: this.colours[(this.lineChartData.datasets.length - 1) % (this.colours.length)],
              backgroundColor: this.colours[(this.lineChartData.datasets.length - 1) % (this.colours.length)],
              pointRadius: 5,
              fill: false,
              borderWidth: 2,
              data: resultList,
              parsing: {
                xAxisKey: 't',
                yAxisKey: 'y'
              }
            }]
          }
        }
        else {
          if (this.lineChartData.datasets.findIndex(chartData => chartData.label === testCode) < 0) {
            console.log('pushing ', this._cumulativeQuery.testCode);
            this.lineChartData.datasets.push(
              {
                label: testCode,
                borderColor: this.colours[(this.lineChartData.datasets.length) % (this.colours.length)],
                backgroundColor: this.colours[(this.lineChartData.datasets.length) % (this.colours.length)],
                pointRadius: 5,
                fill: false,
                borderWidth: 2,
                data: resultList,
                parsing: {
                  xAxisKey: 't',
                  yAxisKey: 'y'
                }
              })
          }
          else {
            console.log("not adding ", this._cumulativeQuery.testCode);
          }
        }
      })
    });
    this.chart?.update();
  }
}
